import DataLayer from "@/helpers/dataLayer";

export default function actions() {
	return {
		fetchCurrentUser: async ({ commit, rootGetters }) => {
			const response = await window.axios.get('/vue/user');
			commit('setCurrentUser', response.data.user);

			if (response.data.user !== null && rootGetters.getCalculation.id === null) {
				commit(
					'setInputData',
					{
						group: 'calculation',
						key: 'birth_date',
						value: response.data.user.birth_date,
						index: null,
					},
					{ root: true },
				);
			}
            if(rootGetters["auth/isAdmin"] || rootGetters["auth/isCustomerService"] || rootGetters["auth/isConsultant"]) {
                DataLayer.push({
                    event: 'userData',
                    visitorLoginState: "logged-in",
                    visitorType: "consultant",
                    userId: rootGetters["auth/getCurrentUser"]?.id,
                });
            } else if(rootGetters["auth/isLoggedIn"]) {
                DataLayer.push({
                    event: 'userData',
                    visitorLoginState: "logged-in",
                    visitorType: "customer",
                    userId: rootGetters["auth/getCurrentUser"]?.id,
                });
            } else {
                DataLayer.push({
                    event: 'userData',
                    visitorLoginState: "logged-out",
                    visitorType: "unknown",
                });
            }
            window.eotthonLoginChecked = true;
            if(typeof window.loadGTM === "function") {
                window.loadGTM();
            }
		},
        fetchOtherUser: async ({ commit, rootGetters}, { userId } ) => {
            const response = await window.axios.get(`/vue/user/${userId}`);
            commit('setCurrentUser', response.data.user);
            if (response.data.user !== null && rootGetters.getCalculation.id === null) {
                commit(
                    'setInputData',
                    {
                        group: 'calculation',
                        key: 'birth_date',
                        value: response.data.user.birth_date,
                        index: null,
                    },
                    { root: true },
                );
            }
        },
        fetchUserList: async ({ commit},{name, birth_date}) => {
            const response = await window.axios.get(`/vue/users`,{
                params:{
                    name,
                    birth_date
                }
            });
            commit('setUserList', response.data);
        },
        fetchBIKAUserList: async ({ commit},{name, birth_date}) => {
            const response = await window.axios.get(`/vue/bika-users`,{
                params:{
                    name,
                    birth_date
                }
            });
            commit('setBIKAListResponse', response.data);
        },
		login: async ({ commit }, { email, password }) => {
			const response = await window.axios.post('/vue/login', {
				email,
				password,
				remember: true,
			}, {
				validateStatus: function (status) {
					return status < 500;
				}
			});

			if(response.status === 200) {
				commit('setCurrentUser', response.data.user);
			} else {
				let errors = {
					'E-mail cím': response.data.errors.email,
				};

				return errors;
			}
		},
		logout: async ({ commit }) => {
			await window.axios.post('/vue/logout');
			commit('setRealEstates', [], { root: true });
			commit('setCurrentUser', null);
		},
		register: async ({ commit, rootGetters }, user) => {
			user.phone = user.phone;
			user.birth_date = rootGetters['getCalculation'].birth_date;
			const response = await window.axios.post('/vue/register', user);

			if (response.data.success) {
				commit('setCurrentUser', response.data.user);
			}

			return response.data;
		},
        simpleRegister: async ({ commit, rootGetters }, user) => {
            const response = await window.axios.post('/vue/simple-register', user);
            return response.data;
        },
        changeToSimpleRegister: async ({ getters }, user_id) => {
            const response = await window.axios.post('/vue/change-to-simple-register', {
                user_id,
            });
            return !!response?.data?.success;
        },
		forgottenPassword: async ({ commit }, email) => {
			const response = await window.axios.post('/vue/forgotten-password', email);

			return response;
		},
		registrationContracting: async ({ rootGetters, commit }, { user, offer }) => {
			const response = await window.axios.post('/vue/register-contracting', {
				user: { ...user, birth_date: rootGetters['getCalculation'].birth_date },
				hash: rootGetters['getCalculation'].hash,
				offer,
			});

			if (response.data.success) {
				commit('setCurrentUser', response.data.user);
			}

			return response.data;
		},
        fetchUserToken: async () => {
            const response = await window.axios.get(`/vue/consultant_token`);
            //todo: error handling
            axios.defaults.headers.common["Authorization"] = `Bearer ${response.data}`;
        },
        fetchIsSimpleRegistration: async ({commit},{hash,insurer_uuid}) => {
            const response = await window.axios.get(`/vue/is_simple_registration`,{
                params:{
                    hash,
                    insurer_uuid
                }
            });
            commit('setSimpleRegistration', response.data.simple);
            commit('setSimpleRegistrationEmail', response.data.email);
        },
        finalizeSimpleRegister: async ({ commit, rootGetters }, user) => {
            const response = await window.axios.post('/vue/finalize-simple-user', user);
            if(response.status === 200) {
                if(response.data?.success === true) {
                    commit('setCurrentUser', response.data.user);
                    return true;
                } else {
                    return response.data;
                }
            }
        },
	};
}
